






















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import alert from "@/mixins/alert";
import { cancelMeetingAlert } from "@/utils/notificationContent";
import constants from "@/constants/_message";
import { ValidationObserver } from "vee-validate";
import { isNotEmpty } from "@/utils/object";

@Component({
  components: {},
})
export default class PolicyForm extends Vue {
  @Action private createTenantPreference: any;
  @Action private updateTenantPreference: any;
  @Getter public tenantPreference: any;
  @Getter public tenantPreferenceInitialData: any;
  @Action public setTenantPreference: any;
  action = "add";
  isSubmitted = false;
  isRefreshList = false;
  $refs!: {
    tenantPreferenceForm: InstanceType<typeof ValidationObserver>;
  };

  beforeMount() {    
    if (this.tenantPreference.id) {
      this.action = "edit";
    }
  }

   isInputRequired() {
    this.tenantPreference.is_input_required = !this.tenantPreference.is_input_required;
    this.tenantPreference.input_value = "";
    this.setTenantPreference(this.tenantPreference);
  }

  onFormSubmit(): void {
    this.isSubmitted = true;
    this.$refs.tenantPreferenceForm.validate().then((success: any) => {
      if (!success) {
        alert.methods.appToaster({
          message: constants.FORM_ERROR,
          type: "ERROR",
        });
        const firstErrorFocused: HTMLFormElement = Object(
          document.querySelector(".error:first-of-type")
        );
        if (
          isNotEmpty(firstErrorFocused) &&
          !firstErrorFocused.classList.contains("IZ-select")
        ) {
          firstErrorFocused.querySelector("input");
          firstErrorFocused.focus();
        }
        
        const errors = Object.entries(this.$refs.tenantPreferenceForm.errors)
          .map(([key, value]) => ({ key, value }))
          .filter((error) => error["value"].length);
        if (errors.length) {
          this.$refs.tenantPreferenceForm.refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      } else {
         this.isRefreshList = true;
        if (this.action === "add") {
          if (!this.tenantPreference.is_input_required) {
            delete this.tenantPreference.input_value;
            delete this.tenantPreference.is_input_required;
          }
          this.createTenantPreference({
            data: this.tenantPreference,
            callback: this.onActionPerformed});
        } else {
          delete this.tenantPreference.created_at;
          delete this.tenantPreference.updated_at;
          delete this.tenantPreference.created_by;
          delete this.tenantPreference.updated_by;
          delete this.tenantPreference.status;
          delete this.tenantPreference.tenantId;

          if (!this.tenantPreference.is_input_required) {
           this.tenantPreference.input_value = "";
          }

          if (this.tenantPreference.is_input_required) {
            if (this.tenantPreference.input_value === null) {
              this.tenantPreference.input_value = "";
            }
          } 
          this.updateTenantPreference({data: this.tenantPreference,
            callback: this.onActionPerformed});
          
        }
      }
    });
  }

  onCancel() {
    this.isRefreshList = false;
     alert.methods.conFirmAlert(
      cancelMeetingAlert,
      () => {
        this.onActionPerformed();
      },
      () => {}
    ); 
  }

  onActionPerformed() {
    this.$emit("actionPerformed", this.isRefreshList);
  }
}
